import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';
import { MEMBRE_VERSION_MENU_MOBILE_SLIDE } from '../../../services/header/constants';

import { toggleMenuMobileSlide } from '../../../services/header/actions';

import { getMenuVersion } from '../../../services/header/selector';

import SvgComponent from '../../SvgComponent';
import LoginButton from './LoginButton';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import LogoutButtonComponent from '../../authentication/logout/LogoutButtonComponent';

class MobileMemberNavComponent extends React.Component {
    componentDidUpdate(prevProps) {
        const { stateOpenMenuMobileSlide, menuMobileVersion } = this.props;

        if (
            !prevProps.stateOpenMenuMobileSlide &&
            stateOpenMenuMobileSlide &&
            menuMobileVersion === MEMBRE_VERSION_MENU_MOBILE_SLIDE
        ) {
            document.addEventListener('keydown', this.trapFocus, false);
            document.querySelector('#mobile-member-menu-button-close').focus();
        }
        if (
            prevProps.menuMobileVersion === MEMBRE_VERSION_MENU_MOBILE_SLIDE &&
            prevProps.stateOpenMenuMobileSlide &&
            !stateOpenMenuMobileSlide
        ) {
            document.removeEventListener('keydown', this.trapFocus, false);
            document.querySelector('#mobile-member-menu-button-open').focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.trapFocus, false);
    }

    trapFocus = e => {
        const focusableElements = 'button, a, [tabindex]:not([tabindex="-1"])';
        const modal = document.querySelector('#connexion-inscription-mobile'); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    };

    onClickBtMenuMobile = e => {
        e.preventDefault();
        this.props.toggleMenuMobileSlide(MEMBRE_VERSION_MENU_MOBILE_SLIDE);
    };

    // Ferme la slide au clic sur l'overlay (la zone sombre hors du panneau) :
    // seul un clic directement sur la slide, pas sur son contenu, est pris.
    onClickOverlay = e => {
        if (e.target === e.currentTarget) {
            this.props.toggleMenuMobileSlide(MEMBRE_VERSION_MENU_MOBILE_SLIDE);
        }
    };

    renderConditionnalAuthenticatedNav = () => {
        const { i18n, isAuthenticated } = this.props;

        if (isAuthenticated) {
            return (
                <div className="menu-membre-mobile-connexion menu-membre-mobile-coinscr">
                    <p className="txtcenter">
                        <LocalizedNavLink to={PATH.ACCOUNT_JACKPOT_PATH} className="connexion ">
                            {i18n.SEE_MY_ACCOUNT}
                        </LocalizedNavLink>
                    </p>
                    <div className="txtcenter logout">
                        <LogoutButtonComponent text={i18n.LOG_OUT} className="fakelink" isText />
                    </div>
                </div>
            );
        }
    };

    renderConditionnalNotAuthenticatedNav = () => {
        const { isAuthenticated } = this.props;

        if (!isAuthenticated) {
            return (
                <div className="menu-membre-mobile-connexion menu-membre-mobile-coinscr txtcenter">
                    <LoginButton />
                </div>
            );
        }
    };

    render() {
        const {
            i18n,
            i18nAccessibility,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide,
            onClickBtMenuMobile,
            hideNav
        } = this.props;
        return (
            <div
                id="connexion-inscription-mobile"
                className={`menu-membre-mobile menu-mobile-slide ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MEMBRE_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : 'closed'
                }`}
                role="dialog"
                aria-label={i18nAccessibility.MODAL_LABEL_MEMBER}
                aria-modal="true"
                onClick={this.onClickOverlay}>
                <div className="menu-mobile-slide-conteneur">
                    <div className="menu-mobile-slide-titre bold flex-container-h flex-center-alt">
                        <div className="menu-membre-ico">
                            <SvgComponent
                                src={`${STATIC_ROOT}/picto-connexion.svg`}
                                width="17"
                                height="17"
                                aria-hidden="true"
                                focusable="false"
                            />
                        </div>
                        {i18n.CUSTOMER_AREA}
                        <button
                            id="mobile-member-menu-button-close"
                            className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                                stateOpenMenuMobileSlide ? 'open' : 'closed'
                            }`}
                            data-target="menu"
                            onClick={this.onClickBtMenuMobile.bind(this)}>
                            <span />
                            <span className="sr-only">
                                {i18nAccessibility.MEMBER_MENU_BUTTON_CLOSE}
                            </span>
                        </button>
                    </div>
                    {this.renderConditionnalAuthenticatedNav()}
                    {this.renderConditionnalNotAuthenticatedNav()}
                </div>

                {hideNav && (
                    <button
                        className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                            stateOpenMenuMobileSlide ? 'open' : 'closed'
                        }`}
                        id="menu-mobile-bt"
                        data-target="menu"
                        onClick={onClickBtMenuMobile.bind(this)}>
                        <span />
                    </button>
                )}
            </div>
        );
    }
}

MobileMemberNavComponent.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired,
    onClickBtMenuMobile: PropTypes.func,
    hideNav: PropTypes.bool
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV,
        i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY,
        menuMobileVersion: getMenuVersion(state)
    };
}

const mapDispatchToProps = {
    toggleMenuMobileSlide
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileMemberNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/MobileMemberNavComponent.js